export const constantsDetails = {
    '0-10_pci': '#000000',
    '11-25_pci': '#4D0A05',
    '26-40_pci': '#EA3223',
    '41-55_pci': '#CD70ED',
    '56-70_pci': '#FFFD54',
    '71-85_pci': '#75F94C',
    '86-100_pci': '#225313',
    '0-10_pci_text': '#fff',
    '11-25_pci_text': '#fff',
    '26-40_pci_text': '#fff',
    '41-55_pci_text': '#fff',
    '56-70_pci_text': '#000',
    '71-85_pci_text': '#000',
    '86-100_pci_text': '#fff',
    BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:9001/'
}
